/** Shared Whole Life Discipleship Volume 3 identity, artwork, and launch data. */
export const WLD_V3_HANDLE = "whole-life-discipleship-curriculum-volume-3";
export const WLD_V3_TITLE = "Whole Life Discipleship Curriculum Volume 3";
export const WLD_V3_SCOPE_PDF = "downloads/wld-volume-3-scope-and-sequence-0d1b25fa5710.pdf";

/** Paths relative to import.meta.env.BASE_URL (local optimized WebP). */
export const WLD_V3_ART = {
  w480: "site/wld-vol3-bundle-480.webp",
  w800: "site/wld-vol3-bundle-800.webp",
  w1200: "site/wld-vol3-bundle-1200.webp",
  width: 1200,
  height: 675,
};

/** Launch: January 1, 2027 at midnight America/Chicago (CST, UTC-6). */
export const WLD_V3_LAUNCH_ISO = "2027-01-01T00:00:00-06:00";
export const WLD_V3_LAUNCH_MS = Date.parse(WLD_V3_LAUNCH_ISO);

export const WLD_V3_SIZES = [
  { label: "1-50", price: "$697.00 USD", presalePrice: "$597.00 USD", savings: 100, percentOff: "14.3", variantId: "54806535143708" },
  { label: "51-250", price: "$897.00 USD", presalePrice: "$747.00 USD", savings: 150, percentOff: "16.7", variantId: "54806535176476" },
  { label: "251+", price: "$1,097.00 USD", presalePrice: "$897.00 USD", savings: 200, percentOff: "18.2", variantId: "54806535209244" },
];
